import { Mail, Phone } from "lucide-react";
import { TableRow, TableCell } from "@/components/ui/table";
import { TypeBadge, StatusPill } from "./ClientBadges";
import { ClientActionsMenu } from "./ClientActionsMenu";
import { initials, avatarColor, fmtDate, displayName } from "./clientConstants";

export function ClientTableRow({ client: c, onView, onEdit, onReset, onArchive, onRestore, onMerge, selected, onToggleSelect }) {
  const name = displayName(c);
  return (
    <TableRow data-testid={`client-row-${c.email}`} className="hover:bg-[#F8FAFC] transition-colors duration-150">
      {onToggleSelect && (
        <TableCell className="w-10">
          <input type="checkbox" data-testid={`client-select-${c.id}`} aria-label={`Select ${name}`} checked={selected} onChange={(e) => onToggleSelect(c.id, e.target.checked)} className="h-4 w-4 rounded border-[#CBD5E1] accent-[#0C2347]" />
        </TableCell>
      )}
      <TableCell>
        <button data-testid={`client-name-link-${c.id}`} onClick={onView} className="flex items-center gap-3 text-left group">
          {c.photo_url ? (
            <img data-testid={`client-row-photo-${c.id}`} src={c.photo_url} alt={name} className="h-10 w-10 shrink-0 rounded-full object-cover border border-[#E4E9F0]" />
          ) : (
            <span className="h-10 w-10 shrink-0 rounded-full grid place-items-center text-sm font-semibold text-[#101828]" style={{ backgroundColor: avatarColor(c.email) }}>{initials(name)}</span>
          )}
          <span className="min-w-0">
            <span className="block font-semibold text-[15px] text-[#101828] group-hover:underline underline-offset-4 truncate">{name}</span>
            {c.team_name && <span className="block text-xs text-[#475467] truncate">{c.team_name}</span>}
          </span>
        </button>
      </TableCell>
      <TableCell className="text-sm text-[#475467] max-w-[160px]"><span className="block whitespace-normal">{c.company || "—"}</span></TableCell>
      <TableCell className="text-sm">
        <a data-testid={`client-email-${c.id}`} href={`mailto:${c.email}`} className="flex items-center gap-1.5 text-[#101828] hover:underline"><Mail size={12} className="text-[#94A3B8]" />{c.email}</a>
        {c.phone && <a data-testid={`client-phone-${c.id}`} href={`tel:${c.phone}`} className="flex items-center gap-1.5 text-[#475467] hover:underline mt-1"><Phone size={12} className="text-[#94A3B8]" />{c.phone}</a>}
      </TableCell>
      <TableCell><TypeBadge type={c.client_type} /></TableCell>
      <TableCell className="font-semibold text-[#0C2347]">{c.orders_count}</TableCell>
      <TableCell className="text-sm text-[#475467] whitespace-nowrap">{fmtDate(c.last_order_at)}</TableCell>
      <TableCell>
        <StatusPill status={c.status} />
        {c.merged_into_name && <div data-testid={`client-merged-hint-${c.id}`} className="text-[11px] text-[#94A3B8] mt-1 whitespace-nowrap">Merged into {c.merged_into_name}</div>}
      </TableCell>
      <TableCell className="text-right"><ClientActionsMenu client={c} onView={onView} onEdit={onEdit} onReset={onReset} onArchive={onArchive} onRestore={onRestore} onMerge={onMerge} /></TableCell>
    </TableRow>
  );
}
